/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Grid from "@mui/material/Grid";
import { useMutation } from "@tanstack/react-query";
import { Card, Pagination } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React components

// Material Dashboard 2 React example components
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";

// Dashboard components
import EmptyResult from "~/components/Extras/Empty";
import MDBox from "~/components/MDBox";
import Cards from "~/components/extended/Cards";
import usePagination from "~/hooks/usePagination";
import { getActiveLocationDetails } from "~/services/location.service";
import { setClickedCardIndex } from "~/store/slices/utilities";

function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    data: locations,
    isLoading,
    isSuccess,
    reset,
    mutate,
  } = useMutation({
    mutationKey: ["locations"],
    mutationFn: (payload) => getActiveLocationDetails(payload),
    onSuccess: (data) => setTotalItems(data?.count),
  });

  const { currentPage, handlePageChange, pageSize, setTotalItems, totalItems } =
    usePagination(mutate, "", 9);

  useEffect(() => {
    mutate({ id: "", currentPage, pageSize });

    return () => {
      reset();
    };
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} height="100%">
        <Grid container spacing={4}>
          {isLoading ? (
            <>
              {Array.from({ length: 4 }, () => 1).map((item, index) => (
                <Grid item lg={3} md={3} key={index}>
                  <Card loading={isLoading} />
                </Grid>
              ))}
            </>
          ) : null}
          {locations
            ? locations["data"].map((values, index) => (
                <Grid item xs={12} md={6} lg={4} key={index}>
                  <MDBox
                    sx={{ cursor: "pointer" }}
                    mb={1.5}
                    onClick={() => {
                      // Update the clicked card index in the state
                      dispatch(
                        setClickedCardIndex({ route: "dashboard", index })
                      );
                      navigate(`/dashboard/location/${values.Loc_Name}`, {
                        state: { name: values.Loc_Name, ...values },
                      });
                    }}
                  >
                    <Cards
                      route="dashboard"
                      index={index}
                      title={values.Loc_Name.toUpperCase()}
                      locationArea={values.Loc_Total_Area}
                      plantations={values.total_area}
                      plants={values?.total_plant}
                      lat={values?.Latitude}
                      long={values?.Longitude}
                      plotCount={values?.Total_Ploting_Count}
                      plotLocation={values?.plotLocations}
                    />
                    {/* <ComplexStatisticsCard
                        color="dark"
                        icon="place"
                        title={values.Loc_Name}
                        count={values.Loc_Total_Area}
                        plantationCount={values.total_area}
                        plantsCount={values.total_plant}
                        percentage={{
                          color: 'success',
                          amount: '+55%',
                          label: 'than lask week',
                        }}
                      /> */}
                  </MDBox>
                </Grid>
              ))
            : null}
          {locations?.count > 9 ? (
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Pagination
                defaultPageSize={9}
                defaultCurrent={currentPage}
                total={totalItems}
                onChange={handlePageChange}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`
                }
              />
            </Grid>
          ) : null}

          {locations?.data?.length === 0 ? (
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <EmptyResult
                description=" No data available. Click below to Create Location "
                navigateTo="/location-master/create"
              />
            </Grid>
          ) : null}
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
// const DashboardDefault = Loadable(lazy(() => Dashboard));
export default Dashboard;
